import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    jobRoleOfferList: {
      requesting: false,
      items: [],
      pagination: {
		  current_page: 1,
		  per_page: 10,
		  total: 0,
	  },
      error: null,
      success: false,
      filters: {},
    },
    jobRoleOfferDetails: {
      requesting: false,
      error: null,
      success: false,
      data: null
    },
  };

export const jobRoleOfferSlice = createSlice({
  name: 'jobRoleOffer',
  initialState,
  reducers: {
    getJobRoleOfferList: (state, action) => {
        state.jobRoleOfferList.requesting = true;
        state.jobRoleOfferList.error = null;
        state.jobRoleOfferList.items = [];
        state.jobRoleOfferList.success = false;
        state.jobRoleOfferList.filters = action.payload;
    },
    getJobRoleOfferListSuccess: (state, action) => {
		const { data, current_page, per_page, total} = action.payload;
        state.jobRoleOfferList.requesting = false;        
        state.jobRoleOfferList.items = data;
        state.jobRoleOfferList.success = true; 
        state.jobRoleOfferList.pagination.current_page = current_page;
        state.jobRoleOfferList.pagination.per_page = per_page;
        state.jobRoleOfferList.pagination.total = total;
    },
    getJobRoleOfferListFail: (state, action) => {        
        state.jobRoleOfferList.requesting = false;
        state.jobRoleOfferList.error = action.payload;
    },

    getJobRoleOfferDetails: (state) => {
        state.jobRoleOfferDetails.requesting = true;
        state.jobRoleOfferDetails.error = null;
        state.jobRoleOfferDetails.data = null;
        state.jobRoleOfferDetails.success = false; 
    },
    getJobRoleOfferDetailsSuccess: (state, action) => {
        state.jobRoleOfferDetails.requesting = false;
        state.jobRoleOfferDetails.data = action.payload;
        state.jobRoleOfferDetails.success = true; 
    },
    getJobRoleOfferDetailsFail: (state, action) => {        
        state.jobRoleOfferDetails.requesting = false;
        state.jobRoleOfferDetails.error = action.payload;
    },

    doJobRoleOfferCreate: (state) => {
        state.jobRoleOfferDetails.requesting = true;
        state.jobRoleOfferDetails.error = null;
        state.jobRoleOfferDetails.data = null;
        state.jobRoleOfferDetails.success = false; 
    },

    doJobRoleOfferUpdate: (state) => {
        state.jobRoleOfferDetails.requesting = true;
        state.jobRoleOfferDetails.error = null;
        state.jobRoleOfferDetails.data = null;
        state.jobRoleOfferDetails.success = false; 
    },
    doJobRoleOfferDelete: (state) => {
        state.jobRoleOfferDetails.requesting = true;
        state.jobRoleOfferDetails.error = null;
        state.jobRoleOfferDetails.data = null;
        state.jobRoleOfferDetails.success = false; 
    },

    getApplicantJobRoleOffer: (state) => {
        state.jobRoleOfferDetails.requesting = true;
        state.jobRoleOfferDetails.error = null;
        state.jobRoleOfferDetails.success = false; 
    },

    doGenerteEmploymentAgreement: (state) => {
        state.jobRoleOfferDetails.requesting = true;
        state.jobRoleOfferDetails.error = null;
        state.jobRoleOfferDetails.success = false; 
    },

  },
})

export const { 
    getJobRoleOfferList, getJobRoleOfferListSuccess, getJobRoleOfferListFail,
    getJobRoleOfferDetails, getJobRoleOfferDetailsSuccess, getJobRoleOfferDetailsFail,
    doJobRoleOfferCreate, doJobRoleOfferUpdate, doJobRoleOfferDelete,
    getApplicantJobRoleOffer, doGenerteEmploymentAgreement,
} = jobRoleOfferSlice.actions

export default jobRoleOfferSlice.reducer